var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg41Covered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84624",
    "data-name": "Group 84624",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 117.15,
    height: 126.992,
    viewBox: "0 0 117.15 126.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24661",
    "data-name": "Rectangle 24661",
    width: 117.15,
    height: 126.992,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84623",
    "data-name": "Group 84623",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240017",
    "data-name": "Path 240017",
    d: "M49.1,126.992a.662.662,0,0,1-.621-.438c-2.57-7.187-5.231-9.052-10.534-12.768-1.625-1.141-3.466-2.431-5.631-4.094-.635-.488-1.318-.989-2.036-1.515-5.173-3.795-12.256-8.989-18.3-21.409C4.8,72.016.884,51,0,22.523a.661.661,0,0,1,.5-.66C14.41,18.305,33.987,11.65,48.233.146A.661.661,0,0,1,49.041.13C64.636,11.738,87.719,18.953,96.919,21.518a.659.659,0,0,1,.482.686c-.056.725-.13,1.86-.213,3.158-.231,3.557-.517,7.984-.762,9.209a.66.66,0,1,1-1.294-.259c.227-1.139.523-5.7.737-9.035.067-1.017.125-1.934.174-2.635-9.512-2.679-31.908-9.8-47.38-21.15C34.444,12.81,15.213,19.421,1.336,23.01c2.072,63.819,19.374,76.51,29.724,84.1.729.533,1.417,1.04,2.061,1.535,2.142,1.644,3.971,2.927,5.585,4.057,5.083,3.564,7.84,5.5,10.357,11.67,1.8-4.182,6.68-9.447,14.541-15.69,3.834-3.043,7.936-5.939,11.555-8.493,1.9-1.336,3.686-2.6,5.164-3.695a.66.66,0,0,1,.785,1.061c-1.491,1.1-3.286,2.371-5.187,3.712-3.607,2.543-7.692,5.427-11.5,8.449-8.8,6.988-13.738,12.627-14.676,16.76a.661.661,0,0,1-.6.512l-.04,0",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240018",
    "data-name": "Path 240018",
    d: "M45.063,108.031a.221.221,0,0,1-.181-.1c-1.32-1.9-5.641-5.659-12.84-11.182C22.454,89.4,16.056,80.28,11.9,68.065,8.239,57.279,6.185,44.03,5.032,23.764a.222.222,0,0,1,.165-.227C22.671,19.061,35.528,13.307,44.507,5.95a.222.222,0,0,1,.275-.005c9.072,7.044,25.107,11.881,34.687,14.771,2.112.637,3.939,1.188,5.256,1.635a.218.218,0,0,1,.148.232l-.055.486c-.127,1.1-.315,2.772-.315,3.195a.22.22,0,0,1-.44,0c0-.449.19-2.132.317-3.244l.035-.31c-1.3-.433-3.052-.963-5.073-1.574-9.561-2.883-25.531-7.7-34.691-14.736-8.993,7.322-21.81,13.055-39.168,17.519,2.012,35.2,6.9,57.194,26.826,72.486,6.923,5.31,11.205,9.014,12.742,11.018C46.864,104.81,55.226,97.07,61.577,92.9a.22.22,0,0,1,.3.063.223.223,0,0,1-.063.3c-6.549,4.3-15.236,12.388-16.565,14.65a.224.224,0,0,1-.181.109Z",
    transform: "translate(3.825 4.484)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240019",
    "data-name": "Path 240019",
    d: "M42.773,38.156a3.229,3.229,0,1,1,2.4,3.886,3.228,3.228,0,0,1-2.4-3.886",
    transform: "translate(32.447 27.115)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240020",
    "data-name": "Path 240020",
    d: "M48.193,24.124V35l7.489,11.971a18.53,18.53,0,0,0,3.283,1.1V23.057Z",
    transform: "translate(36.634 17.527)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240021",
    "data-name": "Path 240021",
    d: "M54.778,53.068c-.607-.97-5.967-9.536-6.585-10.526V58.081L58.965,59.1V50.449Z",
    transform: "translate(36.634 32.338)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240022",
    "data-name": "Path 240022",
    d: "M57.407,51.33a1.072,1.072,0,0,1-.91-.5l-2.286-3.656a1.072,1.072,0,0,1,.613-1.6l7.394-2.132,9.922-6.208a1.08,1.08,0,0,1,.81-.136,1.059,1.059,0,0,1,.667.477L75.9,41.227a1.071,1.071,0,0,1-.34,1.479L65.514,48.992a1.1,1.1,0,0,1-.271.121L57.7,51.288a1.063,1.063,0,0,1-.3.042m-.623-4.091L57.887,49,64.5,47.093l9.012-5.638L72.368,39.62l-9.14,5.719a1.073,1.073,0,0,1-.271.121Z",
    transform: "translate(41.084 28.177)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240023",
    "data-name": "Path 240023",
    d: "M48.658,48.037a1.074,1.074,0,0,1-.57-1.984l6.579-4.115L47.746,30.876a1.073,1.073,0,0,1,1.82-1.137L57.056,41.71a1.073,1.073,0,0,1-.341,1.479l-7.489,4.686a1.062,1.062,0,0,1-.567.164",
    transform: "translate(36.17 22.222)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240024",
    "data-name": "Path 240024",
    d: "M48.658,43.528a1.074,1.074,0,0,1-.57-1.984l7.489-4.685a1.073,1.073,0,0,1,.891-.114c.067.021.19.072.368.146a15.69,15.69,0,0,0,14.618-1.067,4.3,4.3,0,0,1,5.933,1.368l1.144,1.825a1.073,1.073,0,1,1-1.82,1.139l-1.142-1.825a2.157,2.157,0,0,0-2.976-.686,17.83,17.83,0,0,1-16.346,1.329l-7.021,4.392a1.062,1.062,0,0,1-.567.164",
    transform: "translate(36.17 26.731)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240025",
    "data-name": "Path 240025",
    d: "M51.814,49.123a1.076,1.076,0,0,1-.912-.505l-3.156-5.043a1.073,1.073,0,1,1,1.82-1.139l3.156,5.045a1.073,1.073,0,0,1-.341,1.479,1.062,1.062,0,0,1-.567.164",
    transform: "translate(36.17 31.875)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240026",
    "data-name": "Path 240026",
    d: "M53.879,54.649a1.111,1.111,0,0,1-.239-.028,1.062,1.062,0,0,1-.669-.477l-3.429-5.481a1.071,1.071,0,0,1,.34-1.479l8.223-5.145a1.077,1.077,0,0,1,.81-.136,1.06,1.06,0,0,1,.669.477l3.429,5.481a1.071,1.071,0,0,1-.34,1.479l-8.223,5.145a1.078,1.078,0,0,1-.57.164M51.93,48.434,54.22,52.1l6.4-4.006-2.288-3.663Z",
    transform: "translate(37.534 31.832)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240027",
    "data-name": "Path 240027",
    d: "M57.965,76.847c-.037,0-.07,0-.107-.005L36.3,74.687a1.076,1.076,0,0,1-.966-1.068V25.125a1.075,1.075,0,0,1,.966-1.068L57.857,21.9a1.073,1.073,0,0,1,1.179,1.068v52.8a1.069,1.069,0,0,1-1.072,1.074m-20.481-4.2,19.407,1.941V24.156L37.484,26.1Z",
    transform: "translate(26.862 16.644)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg41Covered);
export default __webpack_public_path__ + "static/media/4.1_Covered.5aa4abf51bc5e56afd9f3da71f5c42c2.svg";
export { ForwardRef as ReactComponent };